
const RoadmapManagementSkeleton = () => {
  return (
    <div className="animate-pulse bg-slate-900 p-6 rounded-lg border border-slate-700 min-h-[calc(100vh-100px)]">
      {/* Header section */}
      <div className="flex justify-between items-center mb-6">
        <div className="h-9 bg-slate-700 rounded w-64"></div> {/* Title placeholder */}
        <div className="h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg w-40"></div> {/* Add New Level button placeholder */}
      </div>

      {/* Level list placeholders */}
      <div className="space-y-4">
        {[...Array(3)].map((_, i) => ( // Show 3 placeholder level cards
          <div
            key={i}
            className="bg-slate-800 rounded-xl p-6 border border-slate-700 flex justify-between items-center"
          >
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-slate-700 rounded-full"></div> {/* Icon placeholder */}
              <div>
                <div className="h-6 bg-slate-700 rounded w-48 mb-2"></div> {/* Level Name placeholder */}
                <div className="h-4 bg-slate-700 rounded w-32"></div> {/* Subtitle placeholder */}
                <div className="h-4 bg-slate-700 rounded w-24 mt-1"></div> {/* Session count placeholder */}
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="h-9 w-28 bg-slate-700 rounded-lg"></div> {/* View Sessions button */}
              <div className="h-9 w-9 bg-slate-700 rounded-lg"></div> {/* Edit button */}
              <div className="h-9 w-9 bg-slate-700 rounded-lg"></div> {/* Delete button */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoadmapManagementSkeleton;
